import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import BlogContent from '../components/BlogContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import ViewOrderContent from './components/ViewOrderContent';

class UserViewOrder extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title="View Order"  />
                <ViewOrderContent  id={this.props.params.id}    />  
                <Footer/>
            </div>
        )
    }
}
export default withRouter(UserViewOrder);;